import { TransitionPropertyTypes } from '../../../model/transition-property-types.model';
import { TransitionsService } from '../../../service/transitions.service';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { map, throwError, catchError, of, Observable, forkJoin } from 'rxjs';
import { UserProfileService } from 'src/app/component/user-profile/service/user-profile.service';

@Component({
    selector: 'edit-workflow-transition-properties',
    templateUrl: './edit-workflow-transition-properties.component.html',
    styleUrls: ['./edit-workflow-transition-properties.component.scss']
})
export class EditWorkflowTransitionPropertiesComponent implements OnInit {
    @Input('mat-dialog-close') dialogResult: any;

    isLoading: boolean = false;
    hasPermission: boolean = false;
    permissionIDs: string[] = ['anthony.nguyen', 'lthiru', 'rdiaz2'];

    constructor(
        private transitionsService: TransitionsService,
        private dialogRef: MatDialogRef<EditWorkflowTransitionPropertiesComponent>,
        private userProfileService: UserProfileService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    msg: MsgModel = {};

    ngOnInit(): void {
        this.isLoading = true;
        let obs: Observable<any>[] = [];
        obs.push(this.getPermission());

        forkJoin(obs).subscribe((res) => {
            this.isLoading = false;
        });
    }

    getPermission() {
        return this.userProfileService.getMyProfile().pipe(
            map((res: any) => {
                if (res.user) {
                    this.hasPermission = this.permissionIDs.findIndex((id: any) => id === res.user.USER_ID) >= 0;
                    return res;
                } else if (res.msg) {
                    this.msg = res.msg;
                    return res;
                } else {
                    return throwError(() => new Error('Error retrieving User Profile.'));
                }
            }),
            catchError((err) => {
                return of(err);
            })
        );
    }

    toggleTransitionPropertyType(event: any, transitionPropertyType: TransitionPropertyTypes) {
        if (event.checked) {
            this.createTransitionPropertyType(transitionPropertyType);
        } else {
            this.deleteTransitionPropertyType(transitionPropertyType);
        }
    }

    createTransitionPropertyType(transitionPropertyType: TransitionPropertyTypes) {
        this.transitionsService.createTransitionProperty(this.generateTransitionPropertyPayload(transitionPropertyType)).subscribe({
            next: (res: any) => {
                if (res.transitionProperty) {
                } else if (res.msg) {
                    this.msg = res.msg;
                } else {
                    this.msg = { SUCCESS: false, MSG: 'Error creating transition property type.' };
                }
            },
            error: (err: any) => {
                this.msg = { SUCCESS: false, MSG: 'Error creating transition property type.' };
            },
            complete: () => {}
        });
    }

    deleteTransitionPropertyType(transitionPropertyType: TransitionPropertyTypes) {
        this.transitionsService.deleteTransitionProperty(this.generateTransitionPropertyPayload(transitionPropertyType)).subscribe({
            next: (res: any) => {
                if (res.msg) {
                    this.msg = res.msg;
                } else {
                    this.msg = { SUCCESS: false, MSG: 'Error deleting transition property type.' };
                }
            },
            error: (err: any) => {
                this.msg = { SUCCESS: false, MSG: 'Error deleting transition property type.' };
            },
            complete: () => {}
        });
    }

    generateTransitionPropertyPayload(transitionPropertyType: TransitionPropertyTypes) {
        let payload: any = {};

        payload.transitionID = this.data.role.transitionID;
        payload.transitionPropertyType = transitionPropertyType;

        return payload;
    }

    closeDialog() {
        this.dialogRef.close({ data: this.data });
    }
}
